/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/profile'
export default icon
